/*Seccion imports: Componentes*/ 
import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol} from '../componentes_generales/componentes_formulario/contenedores/';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import 'rc-tooltip/assets/bootstrap.css';
import 'react-tabs/style/react-tabs.css';


/*Seccion imports: Funciones*/
import global_axios from '../../funciones_globales/interaccionapi';
import {
    esEmailValido,
    validarFechaMomentEnFormatoString
} from '../../funciones_globales/utils';
import { cargarCatalogos, cargarCatalogosGenericoAsync, generarItemCatalogoSeleccionado } from '../../funciones_globales/catalogos';
import { validarCampoString } from '../../funciones_globales/utils';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {    formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { generarReporteEnExcel,visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';


class FormVen40  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            pedido: null,
            cliente_sel: undefined,
            vendedor_sel: undefined,
            estadosProforma: undefined,
            estadoActual: '',
            terminosPago: [],
            terminoPago_sel: undefined,
            descTerpago: [],
            DsctoXTermPagoOriginal:null,
            descTerpago_sel: undefined,
        };
        
        this.limpiar = this.limpiar.bind(this);        
        this.generarReporteDevolucionporTipo = this.generarReporteDevolucionporTipo.bind(this);
        this.imprimirExcel = this.imprimirExcel.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getPedidoMovilId = this.getPedidoMovilId.bind(this);
        this.getOptions_Clientes = this.getOptions_Clientes.bind(this);
        this.getClientebyId = this.getClientebyId.bind(this);
        this.getOptions_Vendedores = this.getOptions_Vendedores.bind(this);
        this.changeFormaPago = this.changeFormaPago.bind(this);
        this.changePorcentajeDesc = this.changePorcentajeDesc.bind(this);
        this.actualizarPedido = this.actualizarPedido.bind(this);
        this.imprimirProforma = this.imprimirProforma.bind(this);
        
        
    }

    changeFormaPago(value){
        let porcentajeDsctoPlazo=0;
        /*if(!this.state.esProformaServicio)
        {
          porcentajeDsctoPlazo = value!==null?value.descuento:0
        }*/
        porcentajeDsctoPlazo = value!==null?value.descuento:0
        console.log('Aqui llega Change')
        console.log(value)
        
        this.setState({terminoPago_sel: value!==null?value.value:null, descTerpago_sel:porcentajeDsctoPlazo
        },()=>{
          //this.calculoTotales();
          //this.state.gridDetProformaApi.refreshCells();
        })
    }

    imprimirProforma(){
        let proforma = this.state.pedido;
        visualizarReporteEnPdf('&rpt=1&param1=' + proforma);
      }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 3 ){
          let query = '?tipo=catalogo&cadena_busq=' + input;     
          cargarCatalogosGenericoAsync('/vendedores', query, callback)
        }
      }

    handleInputChange(event){
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
          [name]: value
        });
      }
      
    
      getPedidoMovilId(){
        let idProforma = this.state.pedido;
        let porPlazo =0
        
        if (validarCampoString(idProforma, 6)){      
          //this.props.cambiar_VisualizacionLoading(true);
    
          global_axios({
            method: 'GET',
            url: '/pedidosmoviles/' + idProforma,
          })
          .then((response)=> {
            let proforma = response.data;
            console.log('Profo')
            console.log(proforma)

            let concepto =""
            if (proforma!==null){
             if (proforma.Status.trim().toUpperCase()==="I")
             {  concepto ="IMPRESO"}
             if (proforma.Status.trim().toUpperCase()==="A")
             {  concepto ="NUEVO"}
             if (proforma.Status.trim().toUpperCase()==="B")
             {  concepto ="BLOQUEADO"}
             if (proforma.Status.trim().toUpperCase()==="G")
             {  concepto ="GENERADO"}
             if (proforma.Status.trim().toUpperCase()==="N")
             {  concepto ="ANULADO"}

             if (proforma.PorDescuentoPlazo===null || proforma.PorDescuentoPlazo===undefined){
                porPlazo=(proforma.tb.ValorCuenta1)
              }
              else
              {
                porPlazo=proforma.PorDescuentoPlazo
                
              }


              this.setState({
                cliente_sel: generarItemCatalogoSeleccionado(proforma.Cliente, proforma.cli.Nombre),
                vendedor_sel: generarItemCatalogoSeleccionado(proforma.Vendedor, proforma.vend.Nombre),
                estadoActual: concepto,
                terminoPago_sel: (proforma.TerminoPago.trim()),
                descTerpago_sel: porPlazo,
              });
            }else{
              this.props.cambiar_VisualizacionLoading(false);
              alert(`La proforma: ${idProforma} no existe.`);
            }
          })
          .catch((error)=>{
            alert(error.response?error.response.data.msg:error.message);
          });
        }
        else{
          alert('No ha especificado un No. de Pedido Móvil válido.');
        }
      }
    
    componentDidMount(){
        Promise.all([
            cargarCatalogos('TERPAGO'),
            this.props.generar_LogAuditoriaIngresoForm('0427'),
         ])
        .then(([//estadosProforma, 
            terminosPago
        ]) => {
            
            this.setState({//estadosProforma, 
                terminosPago})
           let ban=0
           terminosPago.forEach((DATA,i)=>{
           var item = {}
           ban=0
           item.value = DATA.descuento;
           item.label = `${DATA.descuento.toString().toUpperCase()} (%)` //DATA.descuento;
                this.state.descTerpago.forEach((new1,a)=>{
                if (new1.value===DATA.descuento){
                ban=1
                }
                })
           if (ban===0){
           this.state.descTerpago.push(item);
        }
      })
        });
        
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0438');
    } 

    generarReporteDevolucionporTipo(){        
        try {

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }
            
            let urlReportWithParams =`&rpt=159&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            visualizarReporteEnPdf(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }
    getOptions_Clientes(input, callback){
        console.log('Ingresa GetOptions')
        if (input.toString().length >= 3 ){
          let query = '?tipo=catalogo&cadena_busq=' + input;     
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
      }
      

    imprimirExcel(){        
        try {

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }
            
            let urlReportWithParams =`&rpt=160&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            generarReporteEnExcel(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){        
        
        this.setState({                
                        descTerpago_sel:null,
                        cliente_sel: null, vendedor_sel: null,
                        terminoPago_sel: null, pedido: '', estadoActual:''
                    });
    }

    getClientebyId(){
        console.log('Ingresa GetClientebyId')
        if (this.state.cliente_sel!==undefined && this.state.cliente_sel!==null){
          let codCliente = this.state.cliente_sel.value;
          let fechaProceso = getFechaProcesoPorModulo('04');
          global_axios({
            method: 'GET',
            url: `/clientes/${codCliente}`
          })
          .then((response)=> {
            let cliente = response.data;
            // Se valida que el status del cliente no sea pasivo.
            if(cliente.status_cli==='P')
            {
              alert('El cliente posee el estado de Pasivo, no se puede continuar...')
              return;
            }
            let emailValido = esEmailValido(cliente.email_representante);
            if (emailValido===false){
              alert('El cliente seleccionado: ' + codCliente + ' no tiene un email registrado. Favor proceda a registrar el email correspondiente.');
              this.setState({ cliente_sel: null });
            }else{
    
              this.setState({ tipoCliente_sel: cliente.tipo, vendedor_sel: generarItemCatalogoSeleccionado(cliente.vendedor.value, cliente.vendedor.label)});
              this.generarDireccionesCliente(cliente);
                            
              // Proceso para consultar si un cliente tiene descuentos habilitados:
              global_axios({
                method: 'GET',
                url: `/clientes/${codCliente}/descuentos?fechaExpiracion=${fechaProceso}`
              })
              .then((response)=> {
                this.setState({descuentosCliente: response.data}, ()=>this.aplicarDescuentosPorCliente(codCliente, this.state.formaPago_sel));
              })
              .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
              });
            }
          })
          .catch((error)=> {
            alert(error.response?error.response.data.msg:error.message);
          });
        }
      }

      changePorcentajeDesc(value){
        let porcentajeDsctoPlazo=0;
        console.log('Revisar')
        console.log(value)
        porcentajeDsctoPlazo = value!==null?value.value:0

        this.setState({ //porcentajeDsctoPlazo:porcentajeDsctoPlazo
          porcentajeDsctoPlazo:value!==null?porcentajeDsctoPlazo:0,
                descTerpago_sel: value!==null?value.value:null
        })
    }

    actualizarPedido(){

        let proformaId = this.state.pedido;
        let descTerpago= this.state.descTerpago_sel
        let terminopago= this.state.terminoPago_sel
        var data = {};
        console.log('datos DescTePago')
        console.log(this.state.descTerpago_sel)
        console.log(this.state.terminoPago_sel)

        if (proformaId === null || proformaId === undefined) {
            alert('No ha seleccionado un pedido movil.');
            return;
          }

          if (descTerpago === null || descTerpago === undefined) {
            alert('No ha seleccionado un porcentaje de descuento.');
            return;
          }

          if (terminopago === null || terminopago === undefined) {
            alert('No ha seleccionado un Termino de pago.');
            return;
          }

          data.proformaId = proformaId;
          data.descTerpago = descTerpago;
          data.terminopago = terminopago;
          data.Usuario = getItemDatosSesion('usuario');


          let config_request = {
            method: 'POST',
            url: 'pedidosmoviles/actualizaTerPago/',
            data
        }
            global_axios(config_request)
            .then((response)=> {                    
                alert(response.data.msg);
                this.imprimirProforma()
                this.limpiar();
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });

            


    }



    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Actualizacion Termino Pago Pedidos Móviles</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Pedido Móvil:</LabelForm>
                            <InputSearch tipoInput='text' nombre='pedido' placeholder='pedido Movil' valor={this.state.pedido}  func_CambiarValor={this.handleInputChange}
                            func_BuscarValor={this.getPedidoMovilId} func_OnFocus={()=>this.limpiar()}
                            />
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-5'>
                            <LabelForm>Cliente:</LabelForm>
                            <ReactSelectAsync value={this.state.cliente_sel} disabled={true}
                            func_onChange={(value)=>{if(Array.isArray(value)){value=null;} }}
                            func_loadOptions={this.getOptions_Clientes}
                            func_onBlur={this.getClientebyId}
                            />
                        </ContainerCol>
                            <ContainerCol className='col-sm-4'>
                            <LabelForm>Vendedor:</LabelForm>
                            <ReactSelectAsync value={this.state.vendedor_sel} disabled={true}
                            func_loadOptions={this.getOptions_Vendedores}
                            func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.setState({vendedor_sel: value})}}/>
                        </ContainerCol>
                        
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Estado Pedido Movil:</LabelForm>
                            <LabelForm> {this.state.estadoActual===null?'':this.state.estadoActual}</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row>               
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Termino Pago Actual:</LabelForm>
                            <ReactSelect 
                            options={this.state.terminosPago} value={this.state.terminoPago_sel}
                            func_onChange={(value)=>{this.changeFormaPago(value)}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Descuento Por Temino Pago Actual:</LabelForm>
                            <ReactSelect searchable={false} options={ this.state.descTerpago } value={this.state.descTerpago_sel} 
                            //func_onChange={(value) => this.setState({descTerpago_sel: value===null?null:value.value})}/>
                            func_onChange={(value)=>{this.changePorcentajeDesc(value)}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>    
                                <button type='button' className='btn btn-success btn-sm' onClick={this.actualizarPedido}><i className="fa fa-print fa-lg" aria-hidden="true"/> Actualizar Pedido Móvil</button>                          
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {//fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            //permiso: state.sesion.valoresSesionForm.Permiso,
            //usuario: state.sesion.valoresSesionForm.Usuario
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});


export default connect (mapStateToProps, mapDispatchToProps)(FormVen40);